import { useGlobalConfig }                    from "context/GlobalContext";
import { RootLayout }                         from "layouts/RootLayout";
import React, { useEffect, useState }         from "react";
import { Box, CircularProgress, Typography }  from "@mui/material";
import { Navigate, 
         Outlet, 
         useLocation
       }                                      from "react-router";

export interface RouteGuardProps {
  children : React.ReactNode
}

export const RouteGuard = () => {

  const { rc } = useGlobalConfig();
  const [loading, setLoading] = useState(true);
  const [initError, setInitError] = useState<string | null>(null);
  const location = useLocation()

  useEffect(() => {

    const init = async () => {
      setLoading(true);
      setInitError(null);
      try {
        const errorMsg = await rc.session.init()
        if (errorMsg) {
          setInitError(errorMsg);
        }
      } catch (e) {
        setInitError(e instanceof Error ? e.message : "Session initialization failed");
      } finally {
        setLoading(false);
      }
    }

    init()
  }, [])
  
  const userLoggedIn = rc.session.isUserLoggedIn();

  if (loading) {
    return (
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 1.5 }}>
        <CircularProgress size={28} />
        <Typography variant="body2" color="text.secondary">
          Loading session…
        </Typography>
      </Box>
    )
  }

  return userLoggedIn ? 
    <RootLayout>
      <Outlet />
    </RootLayout> 
    : 
    <Navigate to="/auth" replace state={{ path : location.pathname, initError }} />
}